import { useState } from 'react'

import { Card, Text, Button, Badge } from '@/ui'
import { UserWithAdminInfo } from '@/reducers/admin/allUsersReducer'
import { useReselector } from '@/utils/sharedHooks'
import {
  getIsAdministrator,
  selectIsBookkeeper,
  selectIsAccountingOpsManager,
} from '@/selectors/user.selectors'
import { TypographyStyles } from '@/styles'
import { UnlockBooksModal } from './UnlockBooksModal'

interface BookLockCardProps {
  user: UserWithAdminInfo
}

export const BookLockCard = ({ user }: BookLockCardProps) => {
  const isAdministrator = useReselector(getIsAdministrator)
  const isBookkeeper = useReselector(selectIsBookkeeper)
  const isAccountingOpsManager = useReselector(selectIsAccountingOpsManager)
  const canUnlockBooks =
    isAdministrator || isBookkeeper || isAccountingOpsManager
  const [unlockModalOpen, setUnlockModalOpen] = useState(false)

  if (!canUnlockBooks) {
    return null
  }

  return (
    <Card className="w-full" id="books-settings">
      <div className="flex items-center justify-between">
        <Text variant={TypographyStyles.H3}>Book Lock Status</Text>
        <Button variant="secondary" onClick={() => setUnlockModalOpen(true)}>
          Manage Locked Book Year
        </Button>
      </div>
      <div className="mt-4 space-y-2">
        <div className="flex items-center gap-2">
          <Text variant={TypographyStyles.BODY_MD}>
            <strong>User Year Lock:</strong>
          </Text>
          {user.booksLockedForUserYear ? (
            <Badge color="blue">{user.booksLockedForUserYear}</Badge>
          ) : (
            <Badge color="gray">Not locked</Badge>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Text variant={TypographyStyles.BODY_MD}>
            <strong>Admin Year Lock:</strong>
          </Text>
          {user.booksLockedForAdminYear ? (
            <Badge color="blue">{user.booksLockedForAdminYear}</Badge>
          ) : (
            <Badge color="gray">Not locked</Badge>
          )}
        </div>
      </div>
      <UnlockBooksModal
        open={unlockModalOpen}
        close={() => setUnlockModalOpen(false)}
        user={user}
      />
    </Card>
  )
}
